import React, { type FC, use, useCallback } from "react";
import { Button, Dropdown, type Key, Label } from "@heroui/react";
import { ChevronDown } from "@gravity-ui/icons";

import { AppSettingsContext } from "@domain/context/AppSettingsProvider";
import { UserContext } from "@domain/context/UserProvider";
import { Lang } from "@domain/intl";

interface Props {
    onLangChange?: (v: string) => void;
}

const menuItems = [
    { key: Lang.De, label: "DE" },
    { key: Lang.En, label: "EN" },
    { key: Lang.Ru, label: "RU" },
];

export const LangDropdown: FC<Props> = () => {
    const { changeLang, intl } = use(AppSettingsContext);
    const user = use(UserContext);

    const handleAction = useCallback((id: Key) => changeLang(id as Lang), [changeLang]);

    if (user.isAuthenticated) {
        return null;
    }
    return (
        <Dropdown>
            <Dropdown.Trigger>
                <Button variant="outline" className="rounded-full bg-app-surface mr-2">
                    {intl.locale.toUpperCase()}
                    <ChevronDown className="size-4" />
                </Button>
            </Dropdown.Trigger>
            <Dropdown.Popover>
                <Dropdown.Menu aria-label="Language selection" onAction={handleAction}>
                    {menuItems.map((item) => (
                        <Dropdown.Item key={item.key} id={item.key} textValue={item.label}>
                            <Label>{item.label}</Label>
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown.Popover>
        </Dropdown>
    );
};
